/* eslint-disable camelcase */
/*
 * @Author: jerryfwang
 * @Date: 2019-04-23 18:02:25
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-08-07 16:18:27
 * 为快报和微视导量的上报逻辑
 */
// @flow
import Url from 'url';
import querystring from 'query-string';
import _ from 'lodash';
import { distributeTest, guideReport } from '@tencent/qb-article-util/lib/guideDirector';
import qIsInstallApk from '@tencent/qb-article-util/lib/appInstall';
import Layer from '../servants/shareObj/Layer';

import { circle as circleServer } from '../fetchers';
import { redirect, localStorage } from './index';
const guideHost = 'https://quan.qq.com/operate/distribute';
export { distributeTest };
type RedirectData = {
  web?: Object,
  app?: Object,
};
function parseKuaibaoUrl(url: string) {
  if (!url) {
    return {};
  }
  try {
    const urlObj = Url.parse(url, true);
    const { pathname, query = {}, ...rest } = urlObj;
    const exec = new Layer('/s/:id');
    const { id } = exec.params(pathname);
    return {
      id,
      pathname,
      query,
      ...rest,
    };
  } catch (error) {
    return {};
  }
}
export const checkKuaiBaoIsGuide = async () => {
  let isGuide = true;
  let isReport = false;
  const install = await qIsInstallApk('kuaibao');
  if (install) {
    const info = localStorage.getItem('USER_GUIDE_MARK');
    if (!info || new Date().getDate() !== new Date(info).getDate()) {
      isGuide = true;
      isReport = true;
    } else {
      isGuide = false;
    }
  }
  console.debug('=============checkKuaiBaoIsGuide', isGuide, install, isReport);
  return { isGuide, install, isReport };
};
export const distributeReport = ({
  logType,
  from,
  sourceId,
  local = '',
  install,
}: {
  logType: number,
  from: number,
  sourceId: string,
  local?: string,
  install?: boolean,
}) => {
  guideReport(
    (reportContent) => {
      circleServer.customerLogReport(reportContent);
    },
    {
      logType,
      from,
      sourceId,
      local,
      install,
    },
  );
};
export const operationInfoReport = (url: string, logType: number) => {
  const type = distributeTest(url);
  distributeReport({
    logType,
    from: type,
    sourceId: '0_2',
    local: 'operation_0',
  });
  return type;
};
const getAppUrl = (id, ext) => {
  // eslint-disable-next-line max-len
  // qnreading://tab_reading?tab=kuaibao&chlid=daily_timeline&kd_insert=article
  let redirectUrl = `qnreading://article_detail?nm=${id}&kd_content_id=${id}`;
  if (ext) {
    redirectUrl += `&${querystring.stringify(ext)}`;
  }
  return redirectUrl;
};
const openKuaiBaoUrl = async (url: string, sourceId: string, { web, app }, extData?: Object = {}) => {
  const { isGuide, install } = await checkKuaiBaoIsGuide();
  const isNew = isGuide ? 1 : 0;
  if (isGuide && install) {
    localStorage.setItem('USER_GUIDE_MARK', new Date().getTime());
  }
  const params = {
    extData: querystring.stringify(extData),
    g_url: url,
    g_source: sourceId,
    g_opt: JSON.stringify({ type: 1, isNew }),
    g_redirect: JSON.stringify({
      web,
      app,
    }),
    g_app: JSON.stringify({
      ADR: 'com.tencent.reading',
      IOS: 'qnreading',
    }),
  };
  const _url = `${guideHost}?${querystring.stringify(params)}`;
  console.debug('===========openKuaiBaoUrl', _url);
  _url && redirect(_url);
};
const openWeiShiUrl = (url: string, sourceId: string, { web, app }, extData?: Object = {}, isH5?: boolean = false) => {
  const params = {
    extData: querystring.stringify(extData),
    g_url: url,
    g_source: sourceId,
    g_opt: JSON.stringify({ type: 0, isNew: 0 }),
    g_redirect: JSON.stringify({
      web,
      app,
    }),
    g_app: JSON.stringify({
      ADR: '',
      IOS: '',
    }),
  };
  const _url = `${guideHost}?${querystring.stringify(params)}`;
  console.debug('===========openWeiShiUrl', _url);
  if (isH5 && _url) {
    window.location.href = _url;
  } else {
    _url && redirect(_url);
  }
};
export const openWeiShiH5Url = (
  url: string,
  redirectData?: RedirectData = {},
  sourceId: string,
  extData?: Object = {},
  isH5?: boolean = false,
) => {
  const { query = {}, ...rest } = Url.parse(url, true) || {};
  const _query = Object.assign(query, redirectData.web || {});
  const web = Url.format({
    query: _query,
    ...rest,
  });
  const app = '';
  openWeiShiUrl(url, sourceId, { web, app }, extData, isH5);
};
// 打开快报导流页地址 如果按照跳转到具体详情页地址 如果没有 跳转到下载页地址
export const openKuaiBaoGuideUrl = (
  url: string,
  redirectData?: RedirectData = {},
  sourceId: string,
  extData?: Object = {},
) => {
  const { id } = parseKuaibaoUrl(url);
  const web = `https://kuaibao.qq.com/newsDownLoad?src=LIULANQI_ARTICLE&${querystring.stringify(redirectData.web)}`;
  const app = getAppUrl(id, redirectData.app);
  openKuaiBaoUrl(url, sourceId, { web, app }, extData);
};

// 得到快报详情页地址
export const openKuaiBaoNewsUrl = (
  url: string,
  redirectData?: RedirectData = {},
  sourceId: string,
  extData?: Object = {},
) => {
  const { id, query, pathname, protocol, ...rest } = parseKuaibaoUrl(url);
  const _query = Object.assign(
    query,
    {
      kd_content_id: id,
    },
    redirectData.web || {},
  );
  const web = Url.format({
    query: _query,
    pathname,
    protocol: 'https:',
    ...rest,
  });
  const app = getAppUrl(id, redirectData.app);
  openKuaiBaoUrl(url, sourceId, { web, app }, extData);
};
// 判断快报是否导流
export const isKuaiBaoGuide = (url: string, preventDistrStatus?: boolean) => {
  const isNotGuide = _.get(window, 'GUIDECONFIG.kb'); // 全局设置屏蔽
  console.debug(
    '====================isKuaiBaoGuide===========',
    `${url}|${isNotGuide}|${(preventDistrStatus || '').toString()}`,
  );
  return !isNotGuide && url && distributeTest(url) === 1 && !preventDistrStatus;
};
